import Vue from "vue";
import GenericTable, { IRow } from "../GenericTable.vue";

/** Classe intermédiaire qui regroupe les paramètres employés par un ou plusieurs type de stratégie (Exemple : sélection). */
export class GenericTableParameters{

    /** GenericTable propriétaire de ses paramètres */
    private context: GenericTable;

    /** Constructeur par défaut */
    public constructor(context: GenericTable){
        this.context = context;
    }

    /** Nom du slot pour la bar d'outils de gauche (placé à la droite immédiate du champ de recherche) */
    public static ToolbarLeft = 'toolbar-left'
    /** Nom du slot pour la bar d'outils de droite (placé au fond à droit sur le même aligement que le champ de recherche) */
    public static ToolbarRight = 'toolbar-right'
    /** Nom du slot pour l'en-tête du menu des fonctionnalités individuelles de gauche (placé entre la checkbox de selection et les colonnes de la liste des colonnes)  */
    public static MenuHeaderLeft = 'menu-header-left'
    /** Nom du slot pour l'en-tête du menu des fonctionnalités individuelles de droite (placé entierement à droite en fin liste des colonnes) */
    public static MenuHeaderRight = 'menu-header-right'
    /** Nom du slot pour le menu des fonctionnalités individuelles de gauche (placé entre la checkbox de selection et les colonnes de la ligne)  */
    public static MenuLeft = 'menu-left'
    /** Nom du slot pour le menu des fonctionnalités individuelles de droite (placé entierement à droite en fin de ligne)  */
    public static MenuRight = 'menu-right'

    /** Affiche le nombre d'éléments sélectionné. */
    private showSelectedCount: boolean = false;

    /** Permet l'utilisation des cases à cocher de selection. */
    private enableSelectorCheckBox: boolean = false;
    /** Permet l'affichage du visuel sur la ligne si elle est selectionnée. */
    private enableSelectorRow: boolean = false;
    /** Permet l'utilisation de la fonctionnalité de selection sur l'ensemble des lignes */
    private enableToggleSelectionAll: boolean = false;

    /** Compteur du nombre de lignes verrouillées en sélection dans la liste des lignes affiché dans la page en cours */
    private countDisplayedRowsLock: number = 0;

    /** Lignes filtrées par le champs de recherche */
    private filteredRows: IRow[] = [];
    /** Lignes affichés sur la page en cours*/
    private displayedRows: IRow[] = [];

    /** Liste des lignes sélectionnées */
    private selectedRows: IRow[] = [];
    /** Liste des lignes internes sélectionnées */
    private selectedDisplayedRows: IRow[] = [];

    /** Est-ce que le slot de la bar d'outils de gauche est utilisé */
    public get IsUsedToolbarLeft(): boolean {
        return this.context.$scopedSlots[GenericTableParameters.ToolbarLeft] !== undefined
    }
    /** Est-ce que le slot de la bar d'outils de droite est utilisé */
    public get IsUsedToolbarRight(): boolean {
        return this.context.$scopedSlots[GenericTableParameters.ToolbarRight] !== undefined
    }
    /** Est-ce que les slots du menu de gauche sont utilisés  */
    public get IsUsedMenuLeft(): boolean {
        return this.context.$scopedSlots[GenericTableParameters.MenuHeaderLeft] !== undefined
            || this.context.$scopedSlots[GenericTableParameters.MenuLeft] !== undefined
    }
    /** Est-ce que les slots du menu de droite sont utilisés  */
    public get IsUsedMenuRight(): boolean {
        return this.context.$scopedSlots[GenericTableParameters.MenuHeaderRight] !== undefined
            || this.context.$scopedSlots[GenericTableParameters.MenuRight] !== undefined
    }
    /** Est-ce que les slots des menus sont utilisés */
    public get IsUsedMenu(): boolean {
        return this.IsUsedMenuLeft
            || this.IsUsedMenuRight
    }

    /** Détermine le nombre de colonnes ajoutées. */
    public get CountAdditionalColumns(): number {
        let count: number = 0;
        if(this.IsUsedMenuLeft)
            count++;
        if(this.IsUsedMenuRight)
            count++;
        if(this.enableSelectorCheckBox)
            count++;
        return count;
    }

    /** Purge les collections contenantes des lignes. */
    public ResetRows() {
        Vue.set(this, 'CountDisplayedRowsLock', 0);

        this.filteredRows.splice(0, this.FilteredRows.length);
        this.displayedRows.splice(0, this.DisplayedRows.length);

        this.selectedRows.splice(0, this.SelectedRows.length);
        this.selectedDisplayedRows.splice(0, this.SelectedDisplayedRows.length);
    }

    //#region GETTEURS / SETTEURS
    public get ShowSelectedCount(): boolean {
        return this.showSelectedCount;
    }

    public get EnableSelectorCheckBox(): boolean {
        return this.enableSelectorCheckBox;
    }

    public get EnableSelectorRow(): boolean {
        return this.enableSelectorRow;
    }

    public get EnableToggleSelectionAll(): boolean {
        return this.enableToggleSelectionAll;
    }

    public get CountDisplayedRowsLock(): number {
        return this.countDisplayedRowsLock;
    }

    public get FilteredRows(): IRow[] {
        return this.filteredRows;
    }

    public get DisplayedRows(): IRow[] {
        return this.displayedRows;
    }

    public get SelectedRows(): IRow[] {
        return this.selectedRows;
    }

    public get SelectedDisplayedRows(): IRow[] {
        return this.selectedDisplayedRows;
    }

    public set ShowSelectedCount(value: boolean) {
        this.showSelectedCount = value;
    }

    public set EnableSelectorCheckBox(value: boolean) {
        this.enableSelectorCheckBox = value;
    }

    public set EnableSelectorRow(value: boolean) {
        this.enableSelectorRow = value;
    }

    public set EnableToggleSelectionAll(value: boolean) {
        this.enableToggleSelectionAll = value;
    }

    public set CountDisplayedRowsLock(value: number) {
        this.countDisplayedRowsLock = value;
    }

    public set FilteredRows(value: IRow[]) {
        this.filteredRows = value;
    }

    public set DisplayedRows(value: IRow[]) {
        this.displayedRows = value;
    }

    public set SelectedRows(value: IRow[]) {
        this.selectedRows = value;
    }

    public set SelectedDisplayedRows(value: IRow[]) {
        this.selectedDisplayedRows = value;
    }
    //#endregion GETTEURS / SETTEURS
}
